import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';

type Props = {
  backgroundColor: string,
  boxProps?: any,
  icon: React.FC<any>,
};

const IconBadge = ({ backgroundColor, boxProps, icon }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        padding: 2,
        backgroundColor,
      }}
      {...boxProps}
    >
      {icon}
    </Box>
  );
};

export default IconBadge;
